export function getFullscreenToggleIndex(player) {
    return player.getChild('ControlBar').children().indexOf(
        player.getDescendant('ControlBar', 'FullscreenToggle')
    );
}
